import {
  MARKETPLACE_V2_PATH,
  MARKETPLACE_V2_STRATEGY_DETAIL_PATH,
} from "features/Explore/routes";

import { DASHBOARD_PATH } from "features/Dashboard/routes";
import { STRATEGY_V2_LIST_PATH } from "features/Strategy/routes";
import { USER_FLAGS } from "utils/constants";

export const FEATURE_LIST = {
  [USER_FLAGS.HAS_BROKER_CONNECTED]: {
    key: USER_FLAGS.HAS_BROKER_CONNECTED,
    title: "Connect your broker account",
    short_description: "Manage your investments",
    description:
      "Surmount connects to the top brokers in the US to make the process of viewing, managing, and automating your investments simple and easy.",
    path: DASHBOARD_PATH,
  },
  [USER_FLAGS.HAS_STRATEGIES_EXPLORED]: {
    key: USER_FLAGS.HAS_STRATEGIES_EXPLORED,
    title: "Explore Strategies",
    short_description: "Find prebuilt strategies",
    description:
      "Find prebuilt trading, investing, and hedging Strategies in the Marketplace. Strategies are created & managed by leading investment advisors, research analysts, and content hosts.",
    path: MARKETPLACE_V2_PATH,
    stepPath: {
      1: MARKETPLACE_V2_STRATEGY_DETAIL_PATH,
    },
  },
  [USER_FLAGS.HAS_INVESTED]: {
    key: USER_FLAGS.HAS_INVESTED,
    title: "Invest in a strategy",
    short_description: "Automate your portfolio",
    description:
      "Invest with Powerful Strategies curated by top investors, analysts and hosts.",
    path: MARKETPLACE_V2_STRATEGY_DETAIL_PATH,
  },
  [USER_FLAGS.HAS_STRATEGY_CREATED]: {
    key: USER_FLAGS.HAS_STRATEGY_CREATED,
    title: "Create your own strategy",
    short_description: "Turn an idea into a Strategy",
    description:
      "Turn any investment idea into an automated, testable, and sharable strategy. Build your own strategies using any datapoint with natural language, no code, or code.",
    path: STRATEGY_V2_LIST_PATH,
  },
};

export const getWalkthroughSteps = (theme) => {
  return {
    [USER_FLAGS.HAS_BROKER_CONNECTED]: [
      {
        disableBeacon: true,
        title: "Go to the dashboard",
        target: ".wt-nav-portfolio",
        placement: "right-start",
        content:
          "In the Dashboard you can view, manage, and automate all of your investments by connecting your broker account. We even provide a Surmount Paper Account for you to test your investment ideas.",
      },
      {
        title: "Connect your broker account",
        target: ".wt-connect-portfolio",
        placement: "bottom",
        content:
          "By connecting your broker account you will be able to automate your  investments. We support 10+ brokers.",
      },
    ],
    [USER_FLAGS.HAS_STRATEGIES_EXPLORED]: [
      {
        disableBeacon: true,
        title: "Explore Strategies",
        target: ".wt-nav-marketplace",
        placement: "right-start",
        content: "Explore Strategies that fits your investment objectives.",
      },
      {
        title: "Investment strategies",
        target: ".wt-investment-strategy",
        placement: "bottom",
        content:
          "Each strategy is a data-driven collection of stocks that reflects an idea.",
        floaterProps: {
          styles: {
            arrow: {
              color: theme.modal.bg.tertiary,
            },
          },
        },
      },
      {
        title: "Investment strategies",
        target: ".wt-investment-strategy-details",
        placement: "right-start",
        content:
          "Data-driven strategies will help automate your portfolio with Strategic investing.",
        floaterProps: {
          styles: {
            arrow: {
              color: theme.modal.bg.tertiary,
            },
          },
        },
      },
    ],
    [USER_FLAGS.HAS_INVESTED]: [
      {
        disableBeacon: true,
        title: "Invest",
        target: ".wt-btn-invest",
        placement: "top",
        content:
          "Invest with confidence. Automate your portfolio with transparent track records strategies. You can also use the Surmount Paper Account to test the performance of a strategy without putting no money at risk.",
      },
    ],
    [USER_FLAGS.HAS_STRATEGY_CREATED]: [
      {
        disableBeacon: true,
        title: "Go to the strategies",
        target: ".wt-nav-own-strategy",
        placement: "right-start",
        content:
          "Boost your portfolio with intelligent investing. Strategies page will allow you to manage your own built strategies.",
      },
      {
        title: "Create a strategy",
        target: ".btn-new-strategy",
        placement: "top",
        content:
          "Build your own strategies using any datapoint with natural language, no code, or code.",
      },
    ],
    welcome: [
      {
        disableBeacon: true,
        title: "Select a strategy for details",
        target: ".wt-suggested-strategy",
        placement: "right-end",
        content:
          "Connect your brokerage account to view, manage, and automate your investments. You can even try out our Surmount Paper Account to test your investment ideas risk-free.",
      },
    ],
    welcomeInvest: [
      {
        disableBeacon: true,
        title: "Click on the invest",
        target: ".wt-btn-invest",
        placement: "left",
        content:
          "Invest with confidence. Automate your portfolio with transparent track records strategies. You can also use the Surmount Paper Account to test the performance of a strategy without putting no money at risk.",
      },
    ],
    investStrategy: [
      {
        disableBeacon: true,
        title: "Start strategy",
        target: ".wt-btn-invest-start",
        placement: "right-start",
        content:
          "Connect your brokerage account to view, manage, and automate all your investments. You can even use our Surmount Paper Account to test your investment ideas risk-free",
      },
    ],
    allocation: [
      {
        disableBeacon: true,
        title: "Click on continue",
        target: ".wt-btn-allocation",
        placement: "right-start",
        content:
          "Explore Strategies: Connect your brokerage account to view, manage, and automate your investments. Plus, try our Surmount Paper Account to test your investment ideas risk-free.",
      },
    ],
    startStrategy: [
      {
        disableBeacon: true,
        title: "Start strategy",
        target: ".wt-btn-start",
        placement: "right-start",
        content:
          "Connect your brokerage account to view, manage, and automate all your investments. You can even use our Surmount Paper Account to test your investment ideas risk-free.",
      },
    ],
  };
};
